import { render, staticRenderFns } from "./Production_D.vue?vue&type=template&id=1d3a6734&scoped=true"
import script from "./Production_D.vue?vue&type=script&lang=js"
export * from "./Production_D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a6734",
  null
  
)

export default component.exports